import React from 'react';
import { Container, Typography, Button, Grid } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { primaryColor,fontfamily } from './UtilColorPalate';

const PaymentFailedPage = () => {
  const navigate=useNavigate();
  const handleNavigate=()=>{
      navigate('/');
  }

  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', paddingTop: '80px' }}>
      {/* <Paper
        elevation={3}
        sx={{ padding: '40px', borderRadius: '12px', backgroundColor: '#fff' }}
      > */}
        <Grid container direction="column" alignItems="center" spacing={4}>
          {/* Error Icon Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <ErrorIcon color="error" sx={{ fontSize: '120px' }} />
            </motion.div>
          </Grid>

          {/* Payment Failed Heading */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#d32f2f' }} fontFamily={fontfamily}>
                Payment Failed!
              </Typography>
            </motion.div>
          </Grid>

          {/* Payment Failure Message */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: 'easeOut' }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                fontFamily={fontfamily}
                textAlign={"left"}
                sx={{ maxWidth: '500px', margin: '0 auto' }}
              >
                Unfortunately, your payment could not be processed. Please try again later or
                contact support if the issue persists.
              </Typography>
            </motion.div>
          </Grid>

          {/* Retry Button */}
          <Grid item>
            {/* <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.7, ease: 'easeOut' }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: '16px',
                  padding: '12px 20px',
                  fontFamily: fontfamily,
                  borderRadius: '50px',
                  fontWeight: '600',
                  transition: '0.3s',
                  '&:hover': {
                    backgroundColor: 'primary',
                    transform: 'scale(1.05)',
                  },
                }}
                onClick={handleRetryPayment}
              >
                Retry Payment
              </Button>
            </motion.div> */}
          </Grid>

          {/* Back to Home Button */}
          <Grid item>
            {/* <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.8, ease: 'easeOut' }}
            > */}
             <Button
                          variant="outlined"
                          onClick={handleNavigate}
                          sx={{
                            mt: 2,
                            px: 4,
                            py: 1,
                            fontFamily: fontfamily,
                            color: primaryColor,
                            borderColor: primaryColor,
                          }}
                        >
                          Back to Home
                        </Button>
            {/* </motion.div> */}
          </Grid>
        </Grid>
      {/* </Paper> */}
    </Container>
  );
};

export default PaymentFailedPage;
